import { push } from 'connected-react-router';
import { isEmpty } from 'lodash';

import { updateQueryString } from '../../../providers/location.provider';
import LocationService from '../../../services/LocationService/LocationService';
import {
    CLEAR_COLLECTION,
    GET_COLLECTION,
    getCollection,
    REMOVE_PRODUCT_FROM_COLLECTION,
    removeProductFromCollection,
    setCollection,
    loadingProduct,
    setCollectionProducts,
    UPDATE_COLLECTION,
    updateCollection,
} from '../../collection';
import { MainStore } from '../../store';
import { setError, setLoader } from '../../ui';

const getCollectionHandler = (store: MainStore, action: ReturnType<typeof getCollection>): void => {
    if (isEmpty(action.payload)) {
        return;
    }

    store.dispatch(setLoader({ collection: true }));
    store.dispatch(setError({ collection: false }));

    LocationService.getProduct({
        urn: action.payload.join(','),
        bookingyear: store.getState().location.bookingYear,
        type: store.getState().router.location.query?.seltype,
    })
        .then(data => store.dispatch(setCollectionProducts(data)))
        .catch(err => store.dispatch(setError({ collection: err })))
        .finally(() => store.dispatch(setLoader({ collection: false })));
};

const updateCollectionHandler = (store: MainStore, action: ReturnType<typeof updateCollection>): void => {
    const {
        router: {
            location: { search },
        },
        collection: { collection, collectionProducts },
    } = store.getState();

    store.dispatch(push({ search: updateQueryString(search, { collection }) }));

    LocationService.getProduct({ urn: action.payload, bookingyear: store.getState().location.bookingYear })
        .then(data => {
            store.dispatch(loadingProduct(false));
            store.dispatch(setCollection([...collection, ...data.data.map(product => product.producturn)]));
            return data;
        })
        .then(data => store.dispatch(setCollectionProducts({ data: [...collectionProducts.data, ...data.data] })))
        .catch(err => store.dispatch(setError({ collection: err })))
        .finally(() => store.dispatch(setLoader({ collection: false })));
};

const clearCollectionHandler = (store: MainStore): void => {
    const {
        router: {
            location: { search },
        },
    } = store.getState();

    store.dispatch(setCollection([]));
    store.dispatch(setCollectionProducts({ data: [] }));
    store.dispatch(push({ search: updateQueryString(search, { collection: [] }) }));
};

const removeProductHandler = (store: MainStore, action: ReturnType<typeof removeProductFromCollection>): void => {
    const {
        router: {
            location: { search },
        },
        collection: { collection, collectionProducts },
    } = store.getState();
    const urn = action.payload;
    const newProducts = collectionProducts.data.filter(product => product.producturn !== urn);
    const newCollection = collection.filter(producturn => producturn !== urn);

    store.dispatch(push({ search: updateQueryString(search, { collection: newCollection }) }));
    store.dispatch(setCollection(newCollection));
    store.dispatch(setCollectionProducts({ data: newProducts || [] }));
};

const collectionHandlers = {
    [GET_COLLECTION]: getCollectionHandler,
    [UPDATE_COLLECTION]: updateCollectionHandler,
    [CLEAR_COLLECTION]: clearCollectionHandler,
    [REMOVE_PRODUCT_FROM_COLLECTION]: removeProductHandler,
};

export default collectionHandlers;
